module.exports = {"520422001":"定南街道","520422002":"穿洞街道","520422003":"黄桶街道","520422101":"马官镇","520422102":"化处镇","520422103":"马场镇","520422104":"白岩镇","520422105":"坪上镇","520422106":"鸡场坡镇","520422203":"补郎苗族乡","520422204":"猴场苗族仡佬族乡","520422205":"猫洞苗族仡佬族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520422.json
// module id = 2292
// module chunks = 0